import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { TripForm } from 'components/forms';
import { getClientList, getLocations } from 'store/clientSlice';
import { search_type } from 'utils';
import { useAuth } from 'hooks';

export default function CreateTrip() {
	const { permissions } = useAuth(); // get the user permissions
	const [formData, setFormData] = useState({});
	const [tripData, setTripData] = useState([]);
	const [trip_reason, setTripReason] = useState([]);
	const { cities = [], statesWithCites } = useSelector((state) => state.clientState);
	console.log(statesWithCites);
	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		console.log('setTripData ', setTripData);
		// Commented due to with out sending limit and offset and also want to remove on trip form line number 1133: values.trip_type === 'replacement'
		// dispatch(
		// 	getClientList({
		// 		search_type: 'trip',
		// 		filter_by: {},
		// 	})
		// ).then((res) => {
		// 	console.log('res', res);
		// 	const data = res?.data?.map((item) => ({
		// 		value: item?.id,
		// 		label: item?.id,
		// 		item,
		// 	}));

		// 	setTripData(data);
		// });
		dispatch(
			getClientList({
				search_type: 'trip_end_reason',
				filter_by: {},
			})
		).then((res) => {
			console.log('res', res);
			const reason_data = res?.data?.map((item) => ({
				value: item?.id,
				label: item?.reason,
			}));
			setTripReason(reason_data);
		});
		if (permissions?.search?.includes('location') || permissions?.search?.includes('all')) {
			dispatch(
				getLocations({
					search_type: search_type?.location,
					filter_by: {},
				})
			);
		}
		if (id) {
			dispatch(
				getClientList({
					search_type: 'trip',
					filter_by: {
						id,
					},
				})
			).then((res) => {
				// console.log('res', res);
				setFormData(res?.data?.[0]);
			});
		}
	}, [dispatch, id]);

	console.log('id', tripData);
	return (
		<TripForm
			isEditMode={Boolean(formData?.id)}
			formData={formData}
			cities={cities}
			tripData={tripData}
			trip_reason={trip_reason}
		/>
	);
}
